<template>
  <div :class="['rank', `rank-${rank}`, rank > 3 ? 'ohter-rank' : '']">{{ rank > 3 ? `#${rank}` : '' }}</div>
</template>

<script setup>
const props = defineProps({
  rank: {
    type: Number,
    default: 1
  }
})
</script>

<style lang="scss">
.rank {
  width: 26px;
  height: 26px;
  &.rank-1 {
    height: 29px;
    background: url('../../assets/images/common/rank/rank1.webp') top no-repeat;
    background-size: cover;
  }
  &.rank-2 {
    height: 29px;
    background: url('../../assets/images/common/rank/rank2.webp') no-repeat;
  }
  &.rank-3 {
    height: 29px;
    background: url('../../assets/images/common/rank/rank3.webp') no-repeat;
  }
  &.ohter-rank {
    color: #777;

    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
